
export class Vehicle {
    public id: number;
    public customerNumberId: number;
    public legacySequenceNumber: string;
    public vin: string;
    public year: number;
    public make: string;
    public model: string;
    public bodyStyle: string;
    public plateNumber: string;
    public plateTypeId: number;
    public vehicleOwnershipPlateStatusTypeId: number;
    public expirationDate: any;
    public titleNumber: string;
}
